import { Select, SelectOption } from "@/components/Global/Select/Select";
import styles from "./GridFilters.module.scss";
import { isTipTopfSortType, useGrid } from "../Grid";
import { StandardCategoryType } from "@/utils/rezeptAPI/getRecipeFilterOptions";
import { GridFilterSection } from "./GridFilterSection";

type GridFiltersProps = {
  showFilterButton: boolean;
  sortOptions: SelectOption[];
  filterOptions: StandardCategoryType[];
};

export const GridFilters = ({
  showFilterButton,
  sortOptions,
  filterOptions,
}: GridFiltersProps) => {
  const { postsTotal, setSortType } = useGrid();

  return (
    <section className={styles["filter-wrapper"]}>
      {showFilterButton && <GridFilterSection filterOptions={filterOptions} />}

      <div className={styles["sort-section"]}>
        <p>{postsTotal >= 0 ? postsTotal : 0} Rezepte</p>
        <Select
          options={sortOptions}
          preSelectedOption={sortOptions[0]}
          onSelect={(value) => {
            if (!isTipTopfSortType(value)) return;
            setSortType(value);
          }}
        />
      </div>
    </section>
  );
};
